


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import { Link, useNavigate } from 'react-router-dom';

const Two3 = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_URL}api/cet/कारोबार`);
                if (response.data && response.data.cetegorie) {
                    setData(response.data.cetegorie.slice(0, 6));
                }
            } catch (error) {
                setError("कारोबार समाचार अभी उपलब्ध नहीं हैं। कृपया बाद में पुनः प्रयास करें।.");
                console.error("There was an error fetching the data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Function to handle navigation with scroll to top
    const handleNavigation = (id) => {
        window.scrollTo(0, 0);
        navigate(`/${id}`);
    };

    if (loading) {
        return (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                {error}
            </div>
        );
    }

    return (
        <div className="container py-4">
            <header className="border-bottom pb-2 mb-4">
                <h1 className="h3 font-weight-bold" style={{ color: '#000', fontFamily: 'Noto Sans, sans-serif', fontSize: '27px' }}>
                    कारोबार
                </h1>
            </header>
            <main className="row mt-4 g-4">
                {data.map((item) => (
                    <div key={item.id} className="col-12 col-md-3 mb-4">
                        <div className="card">
                            {item.link ? (
                                <iframe
                                    src={item.link}
                                    title={item.cetegorieName}
                                    className="img-fluid w-100"
                                    style={{ objectFit: 'cover', height: '200px', borderRadius: '5px' }}
                                />
                            ) : item.image ? (
                                <img
                                    src={`${API_URL}${item.image}`}
                                    alt={item.cetegorieName}
                                    className="img-fluid w-100"
                                    style={{ objectFit: 'cover', height: '200px', borderRadius: '5px' }}
                                />
                            ) : (
                                <div className="img-fluid w-100" style={{ height: '200px', borderRadius: '5px', background: '#ccc' }} />
                            )}

                            <div className="card-body">
                                <span
                                    style={{
                                        color: '#000',
                                        fontFamily: 'Noto Sans, sans-serif',
                                        fontSize: '15px',
                                        lineHeight: '21px',
                                        display: 'block',
                                        marginBottom: '8px',
                                    }}
                                >
                                    {item.cetegorieName}
                                </span>

                                <div>
                                    <p
                                        style={{
                                            color: '#333',
                                            height: '45px',
                                            fontFamily: 'Noto Sans, sans-serif',
                                            fontSize: '15px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: '4',
                                            WebkitBoxOrient: 'vertical',
                                            marginBottom: '10px',
                                        }}
                                        className="font-weight-bold"
                                    >
                                        {item.short_description}
                                    </p>
                                    <button
                                        onClick={() => handleNavigation(item.id)}
                                        className="btn btn-primary"
                                        style={{
                                            backgroundColor: '#007bff',
                                            border: 'none',
                                            padding: '8px 16px',
                                            borderRadius: '4px',
                                            color: 'white',
                                            fontFamily: 'Noto Sans, sans-serif',
                                            fontSize: '14px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        और पढ़ें
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </main>
        </div>
    );
};

export default Two3;


